/**
 * 운영자 공지 본문(HTML) 유틸.
 */

export function isSystemNoticeContentEmpty(html) {
  if (html == null || String(html).trim() === '') return true
  if (typeof document === 'undefined') return false
  const tmp = document.createElement('div')
  tmp.innerHTML = html
  const text = (tmp.textContent || '').replace(/\u00a0/g, ' ').trim()
  return text === ''
}
